import { createChildListModalContainer } from 'factories/ChildListModal'
import actions from 'actions/lists/listItems'
import Component from '../components/FileItems'

export default createChildListModalContainer({ actions })(Component)
